import React, { useEffect, useContext } from 'react'
import { useHistory } from 'react-router-dom'
import AuthProvider from '../guards/AuthProvider.js'
import axios from 'axios'
import itb from '../assets/logo_itb.png'
import '../styles/login.css'
const buildUrl = require('build-url')

function Login() {
    const LOGIN_URL = 'https://login.itb.ac.id/cas/login'
    const CALLBACK_URL = '/login'
    const [auth, setAuth] = useContext(AuthProvider);
    let history = useHistory()
    
    const getParamFromCurrentUrl = param => {
        return new URL(window.location.href).searchParams.get(param)
    }
    
    const getBaseUrl = () => {
        return window.location.protocol + "//" + window.location.host
    }
    
    const getLoginUrl = () => {
        const PARAM = {
            service: getBaseUrl() + CALLBACK_URL
        }

        return buildUrl(LOGIN_URL, {
            queryParams: PARAM
        })
    }

    useEffect(() => {
        const ticket = getParamFromCurrentUrl('ticket')
        if (ticket) {
            const serviceUrl = getBaseUrl() + CALLBACK_URL
            axios.post(getBaseUrl() + '/api/login', {ticket, serviceUrl}).then(res => {
                console.log('success')
                setAuth({
                    token: res.data.token
                })
                history.push('/')
            }).catch(err => {
                console.log(err)
            })
        }
    }, [])

    return (
        <div className="login">
            <h2>Web Energy Monitoring</h2>
            <img src={itb} alt="logo_itb" className="logo_itb" />
            <a href={getLoginUrl()}><button>Login with SSO (INA)</button></a>
        </div>
    )
}

export default Login;
